import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import * as moment from 'moment';

import {Field, FieldType} from '../member-addedit/member-addedit.component';
import {ClientEligibilityProduct, ClientQleEligibilityRequest} from '../../../services/usersinsurance/users.insurance.service';

function endDateValidator(control: AbstractControl): ValidationErrors | null {
  const startDate = control.parent?.get('Start Date')?.value;
  if (!startDate || !control.value) {
    return null;
  }
  return moment(control.value).isBefore(moment(startDate), 'day')
    ? {dateRange: true}
    : null;
}

export function buildClientQleFields(
  products: ClientEligibilityProduct[],
  multipleProducts: boolean,
): Field[] {
  return [
    {
      name: 'Products',
      label: multipleProducts ? 'Products' : 'Product',
      fieldType: FieldType.F_DROPDOWN,
      values: products.map(product => `${product.label}:${product.id}`),
      multiple: multipleProducts,
      required: true,
    },
    {
      name: 'Start Date',
      label: 'Eligibility Start Date',
      fieldType: FieldType.F_ANYDATE,
      required: true,
    },
    {
      name: 'End Date',
      label: 'Eligibility End Date',
      fieldType: FieldType.F_ANYDATE,
      required: true,
      validators: [endDateValidator as ValidatorFn],
      errorMessages: {dateRange: 'Eligibility End Date must be on or after Eligibility Start Date'},
    },
    {
      name: 'Event Type',
      label: 'Event Type',
      fieldType: FieldType.F_DROPDOWN,
      values: ['New Hire:new_hire', 'Qualifying Life Event:qualifying_life_event'],
      required: true,
    },
    {
      name: 'Note',
      label: 'Note',
      fieldType: FieldType.F_STRING,
      required: false,
      validators: [((control: AbstractControl): ValidationErrors | null => (
        `${control.value || ''}`.length > 500 ? {maxlength: true} : null
      )) as ValidatorFn],
      errorMessages: {maxlength: 'Note cannot exceed 500 characters'},
    },
  ];
}

export function toClientQleRequest(value: any): ClientQleEligibilityRequest {
  return {
    productIds: Array.isArray(value.Products) ? value.Products : [value.Products],
    startDate: moment(value['Start Date']).format('YYYY-MM-DD'),
    endDate: moment(value['End Date']).format('YYYY-MM-DD'),
    eventType: value['Event Type'],
    note: `${value.Note || ''}`.trim() || undefined,
  };
}
